export const hideRecaptchaBadge = () => {
  const badge = document.querySelector<HTMLElement>('.grecaptcha-badge')

  if (badge) {
    badge.style.visibility = 'hidden'
  }
}
